import React, { FormEvent, useCallback, useState } from 'react'
import { BiImageAdd } from 'react-icons/bi'
import useApi from '../../hooks/useApi'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import { ImageInput } from '../../Korbantech/components/Inputs/ImageInput'
import { TextInput } from '../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../Korbantech/components/Label'
import { Onboarding } from '../../types/Onboarding'

export const NewOnboarding = ({onboarding}:Props) => {

    const api = useApi()
    const [ logo, setLogo ] = useState<string>( )

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        if (onboarding) {
            data.append('_method', 'PATCH')
            return await api.post(`/admin/onboarding/${onboarding.id}`, data).then(res => {
                window.location.reload()
            }).catch(console.log)
        }

        await api.post("/admin/onboarding", data).then(res => {
                window.location.reload()       
         }).catch(console.log)

    }, [api, onboarding])


     return(
         <form className='w-80' onSubmit={handleSubmit}>
             <div className='font-semibold'>Novo banner</div>
             <div className=''>
             <Label>
                     Título
                     <TextInput className={"rounded-lg"} name="title" defaultValue={onboarding?.title}/>
                 </Label>
                 <Label>
                     Descrição
                     <TextInput className={"rounded-lg"} name="description" defaultValue={onboarding?.description} />
                 </Label>
                 <Label>
                     Posição
                    <TextInput className={"rounded-lg"} type="number" name="step" defaultValue={onboarding?.step}/>
                 </Label>
                 <Label>
                Logo
                <div className="flex items-center w-40 h-40 overflow-hidden m-auto">
                    { logo
                        ? <img className='object-cover w-full' height="auto"  src={ logo } alt="" />
                        : <BiImageAdd className="text-4xl m-auto"/>
                    }
                </div>
                <div  className="h-0 overflow-hidden">
                    <ImageInput name="banner" onProccessImages={ ( urls:string[] ) => urls[0] && setLogo( urls[0] ) }/>
                </div>
            </Label>
             </div>
             <SubmitButton value={"Salvar"}/>
         </form>
     )
}

interface Props {
    onboarding?:Onboarding
    closeModal?:()=>void
}